import {ReactElement} from 'react';
import parse, {Element} from 'html-react-parser';

import HighlightBlock from '../HighlightBlock.client';
import {WhiskyBarType} from '../../types';

interface ParsedBarContentProps {
  whiskyBar: WhiskyBarType;
}

export default function ParsedBarContent({
  whiskyBar,
}: ParsedBarContentProps): ReactElement {
  const totalEmbeddedHighlights = whiskyBar.highlights.length;

  return (
    <div className="text-content">
      {parse(whiskyBar.content, {
        replace: (domNode: Element) => {
          // -- embed highlights
          const match = domNode?.attribs?.id?.match(
            /embed_highlights-([0-9]+)/,
          );
          if (match && totalEmbeddedHighlights) {
            const highlightNumber = parseInt(match[1]);
            if (highlightNumber < totalEmbeddedHighlights) {
              const highlight = whiskyBar.highlights[highlightNumber];
              return (
                <>
                  <br />
                  <HighlightBlock key={highlight.title} highlight={highlight} />
                  <br />
                </>
              );
            }
          }
        },
      })}
    </div>
  );
}
